import ModelUtil from '@leverege/model-util';
import { Attributes } from '@leverege/ui-attributes';
import FieldModel from "./GroupedTextFilterFieldModel.js";
import FieldFilterFactory from "./TypeToFieldFilter.js";
const imagineType = 'groupedText';
const TYPE = `filter.${imagineType}`;
function toInterfixSearch(search) {
  if (!search) {
    return search;
  }
  if (typeof search !== 'string') {
    return '';
  }
  return `*${search}*`;
}
function tokenize(search) {
  if (!search) {
    return [['']];
  }
  const arr = search.trim().split(',');
  const tokens = arr.map(item => item.split(/\s+/));
  return tokens;
}
function getLastToken(search) {
  const tokens = tokenize(search);
  const lastSearch = tokens[tokens.length - 1];
  const lastToken = lastSearch[lastSearch.length - 1];
  return lastToken;
}

// TODO : always assumes the last thing in the search is whats being edited, might not be right
function getLastCompleteSearch(search) {
  const tokens = tokenize(search);
  const lastSearch = tokens[tokens.length - 1];
  lastSearch.pop();
  return lastSearch.join(' ');
}
function getLastSearch(search) {
  const tokens = tokenize(search);
  const lastSearch = tokens[tokens.length - 1];
  return lastSearch.join(' ');
}
function getInterfixLastTokenSearch(search) {
  const cmp = getLastCompleteSearch(search);
  return `${cmp ? `${cmp} ` : ''}${toInterfixSearch(getLastToken(search))}`;
}
function getCompleteInterfixLastTokenSearch(search) {
  const tokens = tokenize(search);
  const nTokens = tokens.map(iSearch => {
    const nSearch = [...iSearch];
    nSearch[nSearch.length - 1] = toInterfixSearch(nSearch[nSearch.length - 1]);
    return nSearch;
  });
  return nTokens.map(t => t.join(' ')).join(',');
}
function getAllButLastToken(search) {
  const tokens = tokenize(search);
  const lastSearch = tokens[tokens.length - 1];
  lastSearch.pop();
  return tokens.map(t => t.join(' ')).join(',');
}
function getAllButLastSearch(search) {
  const tokens = tokenize(search);
  return tokens.slice(0, -1).map(t => t?.join(' ')).join(',');
}
function toImagineField(field, objType) {
  const attr = Attributes.getAttribute(field.attrName, objType);
  if (attr?.blueprint?.field) {
    return FieldFilterFactory.create(attr?.valueType, attr, objType);
  }
  return null;
}
function toImagineFilter(model, objType) {
  const toReturn = {
    type: imagineType
  };
  // no fields means search the whole device
  if (Array.isArray(model?.fields)) {
    toReturn.fields = [];
    for (let i = 0; i < model.fields.length; i++) {
      const field = model.fields[i];
      const toAdd = toImagineField(field, objType);
      if (Array.isArray(toAdd)) {
        toReturn.fields.push(...toAdd);
      } else if (toAdd) {
        toReturn.fields.push(toAdd);
      }
    }
  }
  return toReturn;
}
function toImagineValue(search, model, objType, options) {
  let toReturn;
  if (Array.isArray(model?.fields) && model?.fields?.length > 0) {
    // let the search handle it all
    toReturn = search;
  } else if (options?.complete === false) {
    // default to interfix of final token
    toReturn = getInterfixLastTokenSearch(search);
  } else {
    toReturn = getCompleteInterfixLastTokenSearch(search);
  }
  return toReturn;
}
function create(fields = []) {
  return {
    type: TYPE,
    fields,
    value: null
  };
}
export default {
  TYPE,
  type: TYPE,
  create,
  ...ModelUtil.createAllArray('fields'),
  field: FieldModel,
  toImagineFilter,
  getAllButLastToken,
  getAllButLastSearch,
  getLastToken,
  tokenize,
  getLastSearch,
  getLastCompleteSearch,
  toInterfixSearch,
  getInterfixLastTokenSearch,
  getCompleteInterfixLastTokenSearch,
  toImagineValue
};